export const API_URL = process.env.REACT_APP_ADMIN_API_URL || 'http://localhost:50500';
export const TAROFF_API_URL = process.env.REACT_APP_TAROFF_API_URL || 'http://localhost:50502';

const getHeaders = () => {
    const headers = {
        'Content-Type': 'application/json',
    };

    const token = localStorage.getItem('admin_auth_token');
    if (token) {
        headers['Auth-Token'] = token;
    }

    return headers;
};

const handleResponse = async (response) => {
    if (response.status === 401) {
        localStorage.removeItem('admin_auth_token');
        window.location.href = '/admin/site-admin/login';
        throw new Error('Unauthorized');
    }

    const data = await response.json();
    if (!response.ok) {
        throw data;
    }
    return data;
};

export const getData = async (url) => {
    try {
        const response = await fetch(API_URL + url, {
            method: 'GET',
            headers: getHeaders(),
            credentials: 'include'
        });
        return handleResponse(response);
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

export const postData = async (url, data) => {
    try {
        const response = await fetch(API_URL + url, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(data),
            credentials: 'include'
        });
        return handleResponse(response);
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

export const postFile = async (url, data) => {
    const response = await fetch(API_URL + url, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(data),
        credentials: 'include',
    });
    if (!response.ok) {
        await handleResponse(response);
    }
    return response.blob();
};

export const putData = async (url, data) => {
    try {
        const response = await fetch(API_URL + url, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify(data),
            credentials: 'include'
        });
        return handleResponse(response);
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

export const deleteData = async (url) => {
    try {
        const response = await fetch(API_URL + url, {
            method: 'DELETE',
            headers: getHeaders(),
            credentials: 'include'
        });
        return handleResponse(response);
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};
